import type { IconType } from '@/lib/types'

export function getRoleIcon(role: string): IconType | null {
    switch (role) {
        case 'admin':
            return 'security'
        case 'clerical':
            return 'briefcase'
        case 'workforce':
            return 'account-group'
        default:
            return null
    }
}

export function getRoleColor(role: string) {
    switch (role) {
        case 'admin':
            return '$blue10'
        case 'clerical':
            return '$gray10'
        case 'workforce':
            return '$gray8'
        default:
            return '$gray10'
    }
}

export function formatRole(role: string): string {
    return role.charAt(0).toUpperCase() + role.slice(1)
}

export function formatJoinDate(date: Date): string {
    return new Date(date).toLocaleDateString()
}

export function formatLastActivity(lastActivity: string | undefined): string {
    if (!lastActivity) return 'Never'
    const d = new Date(lastActivity)
    return `${d.toLocaleDateString()} ${d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`
}

export const MOCK_MEMBERS = [
    {
        id: '1',
        userId: '1',
        userOrgId: 'uo1',
        role: 'admin',
        createdAt: new Date('2024-01-15T00:00:00'),
        user: {
            id: '1',
            name: 'Alice Johnson',
            email: 'alice@baro.com',
            image: null,
        },
    },
    {
        id: '2',
        userId: '2',
        userOrgId: 'uo2',
        role: 'admin',
        createdAt: new Date('2024-02-20T00:00:00'),
        user: {
            id: '2',
            name: 'Bob Smith',
            email: 'bob@baro.com',
            image: null,
        },
    },
    {
        id: '3',
        userId: '3',
        userOrgId: 'uo3',
        role: 'clerical',
        createdAt: new Date('2024-03-10T00:00:00'),
        user: {
            id: '3',
            name: 'Carol Davis',
            email: 'carol@baro.com',
            image: null,
        },
    },
    {
        id: '4',
        userId: '4',
        userOrgId: 'uo4',
        role: 'clerical',
        createdAt: new Date('2024-03-25T00:00:00'),
        user: {
            id: '4',
            name: 'David Wilson',
            email: 'david@baro.com',
            image: null,
        },
    },
]
